var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5049 37.498C78.5049 56.8339 62.83 72.5088 43.4941 72.5088C24.1582 72.5088 8.4834 56.8339 8.4834 37.498C8.4834 18.1621 24.1582 2.4873 43.4941 2.4873C62.83 2.4873 78.5049 18.1621 78.5049 37.498Z",
    fill: "#A3E2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0527 36.9942C74.0527 20.5221 60.6995 7.16895 44.2275 7.16895M74.0527 36.9942L66.8536 31.3376M74.0527 36.9942L79.7092 31.8519",
    stroke: "black",
    strokeWidth: 1.92061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2275 75.0449C60.6995 75.0449 74.0527 61.6917 74.0527 45.2197M44.2275 75.0449L49.884 67.8457M44.2275 75.0449L49.3698 80.7014",
    stroke: "black",
    strokeWidth: 1.92061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6914 45.2217C6.6914 61.6937 20.0446 75.0469 36.5166 75.0469M6.6914 45.2217L13.8906 50.8782M6.6914 45.2217L1.03489 50.3639",
    stroke: "black",
    strokeWidth: 1.92061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0313 6.65624C20.5593 6.65624 7.20605 20.0094 7.20605 36.4814M37.0313 6.65624L31.3748 13.8554M37.0313 6.65624L31.889 0.999734",
    stroke: "black",
    strokeWidth: 1.92061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.3135b9d891bd76ab70bb246900bc8eea.svg";
export { ForwardRef as ReactComponent };